export function reactionGQLFields(fields) {
    var _a;
    return `
    count
    reacted
    reaction

    ${(fields === null || fields === void 0 ? void 0 : fields.fields) === 'all'
        ? `
    participants(limit: ${((_a = fields === null || fields === void 0 ? void 0 : fields.variables) === null || _a === void 0 ? void 0 : _a.limit) || 25}) {
      nodes {
        participant {
          id
          name
        }
      }
    }`
        : ``}
  `;
}
//# sourceMappingURL=reaction.fields.js.map